import styled from 'styled-components';
import {
  MainButton,
  MainButtonSection,
} from '../../styles/GlobalStyledComponents';

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 200px;
  gap: 24px;
  margin-top: 16px;
`;

export const TextHeader = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
`;

export const Title = styled.span`
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  line-height: 32px;
  text-align: center;
`;

export const Subtitle = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
`;

export const ImgContainer = styled.span`
  display: flex;
  justify-content: center;
  margin: 16px 0;
`;

export const SvgImg = styled.img`
  width: 306px;
  height: 191px;
`;

export const ExistingRfnButtonSection = styled(MainButtonSection)`
  justify-content: center;
`;

export const ExistingRfnButton = styled(MainButton)`
  max-width: 343px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
